<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GrSSZk/tc-custom/9781459238046.jpg?1705007640543" alt="This image is the cover for the book Contract with Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contract with Consequences
      </h1>
      <p class="bookDescription body article font2">
        <p>Last year, Scarlet King was a blushing bride-to-be, but now she's alone and more than anything she longs for a baby. This time, she's determined to prove she doesn't need a man!<br/><br/>Successful, spine-tinglingly gorgeous John Mitchell has desired Scarlet for years, so he seizes the chance to claim her. But his proposal comes with a devilish price: if she wants a baby, they'll do it the old-fashioned way!<br/><br/>John reminds Scarlet of the pleasures she's been missing, but when the affair is over, will Scarlet gain her wish, but lose her heart?<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miranda Lee
      </h2>
      
      <p class="authorDescription body article">After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6049449c